export default __webpack_public_path__ + "static/injured-71e9adde4c8bc6e35755cea3f3ab75c2.svg";